import React from 'react'
import { Grid, Table, Row, Col, Panel, FormGroup, Checkbox, Button, Radio, Image } from 'react-bootstrap';

import Message from '../../lib/Message'

import DateHelpers from '../../lib/DateHelpers'

import { conversations, conversation } from '../../lib/Conversations'
import Conversation from '../../lib/Conversation'


import { EditModal, NotificationModal } from '../../components/Modals'

class ConversationPopup extends React.Component {
    state = {
        loading: true,
        messages: [],

    }

    getConversation = async() => {
        const conversationObject = await conversation(this.props.conversationId, 1000, 0);
        this.setState({
            loading: false,
            messages: conversationObject.conversation.messages.map((message) => new Message(message))
        })
        console.log(conversationObject);
    }

    componentDidMount() {
        this.getConversation()
    }

    getStyles() {
        return {
            container: {
                position: 'fixed',
                width: '100%',
                top: '0px',
                left: '0px',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.5)',
                padding: '100px'
            },
            inner_container: {
                width: '100%',
                height: '100%',
                backgroundColor: 'white',
                flexDirection: 'column',
                overflowY: 'scroll',
                alignItems: 'center',
            },

        }
    }
    render() {
        var styles = this.getStyles()
        return (
            <div style = {styles.container}>
                <div style = {styles.inner_container}>
                    <Button onClick = {(e)=>{this.props.hideModal()}} >Close x</Button>
                    <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            <th>Sender</th>
                            <th>Message</th>
                            <th>Sent Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.messages.map((message, index)=>{
                                console.log(message)
                                return (
                                    <tr >
                                        <td>{message.first_name + ' ' + message.last_name}</td>
                                         <td>{message.message}</td>
                                         <td>{DateHelpers.timeStampToLabel(message.created_at, true)}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
                </div>
            </div>)
    }
}



class Conversations extends React.Component {
    state = {
        loading: true,
        conversations: [],
        show_popup: false
    }

    getConversations = async() => {
        const conversationList = await conversations(1000, 0);
        console.log(conversationList)
        this.setState({
            loading: false,
            conversations: conversationList.conversations.map((conversation) => new Conversation(conversation))
        })
        console.log(conversationList);
    }

    componentDidMount() {
        this.getConversations()
    }

    render() {
        return (
            <div>
                <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Most recent activity</th>
                            <th>Most recent message</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.conversations.map((conversation, index)=>{
                                // console.log(conversation)
                                if ( conversation.participants[0].swipecast_user_id!= "2a0051934621c66300519d47b9df5adb20d2ea556370" && conversation.participants[1].swipecast_user_id!= "2a0051934621c66300519d47b9df5adb20d2ea556370")
                                {
                                    return (
                                        <tr onClick = {()=>{this.setState({show_popup: true, conversationId: conversation.id})}}>
                                            <td>{conversation.participants[0].first_name + ' ' + conversation.participants[0].last_name }</td>
                                            <td>{conversation.participants[1].first_name + ' ' + conversation.participants[1].last_name }</td>
                                            <td>{DateHelpers.timeStampToLabel(conversation.last_activity, true)}</td>
                                            <td>{conversation.messages[0]? conversation.messages[0].message : 'No Messages Yet'}</td>
                                        </tr>

                                    )
                                }
                            })
                        }
                    </tbody>
                </Table>
                {
                    this.state.show_popup == true && <ConversationPopup hideModal = {()=>{this.setState({show_popup: false})}} conversationId = {this.state.conversationId} />
                }
            </div>
        )
    }
}

export default Conversations;
